module.exports = __webpack_public_path__ + "img/dur-off.d9f5f39d.svg";